import { LOAD_EVENT_DATA } from "../types";


export const loadEventData = (payload) => ({
  type:LOAD_EVENT_DATA,
  payload
})